export default {
  configUrl: process.env.REACT_APP_CONFIG_URL || '/config.json',
  apiDateFormat: 'YYYY-MM-DD',
  apiDateTimeFormat: process.env.REACT_APP_API_DATE_FORMAT || 'YYYY-MM-DD HH:mm:ss',
  services: {
    auth: {
      baseUrl: 'http://localhost:5000/uaa',
    },
    account: {
      baseUrl:  'http://localhost:4000/accounts',
    },
    shoes: {
      baseUrl: 'http://localhost:7073/shoes',
    },
    marking: {
      baseUrl: process.env.REACT_APP_API_MARKING_BASE_URL || process.env.REACT_APP_API_SHOES_BASE_URL || '',
    },
    keycloak: {
      baseUrl: 'https://account-marking-01.korusconsulting.ru/auth',
      realm: process.env.REACT_APP_API_KEYCLOAK_REALM || 'marking', // #TODO remove
      clientId: process.env.REACT_APP_API_KEYCLOAK_CLIENT_ID || 'marking',
      clientSecret: process.env.REACT_APP_API_KEYCLOAK_CLIENT_SECRET || 'marking',
    }
  }
}